import StatusBadge from "../../generals/StatusBadge";

function formatValue(value) {
  if (value === null || value === undefined || value === "") return "-";
  return String(value);
}

function DetailRow({ label, value }) {
  return (
    <div className="mt-2 flex flex-row items-start text-gray-700">
      <div className="w-[140px] flex-shrink-0 text-sm mr-2">{label}</div>
      <div className="text-xs font-bold break-words">{formatValue(value)}</div>
    </div>
  );
}

function DesignationOverview({ designation }) {
  if (!designation) return null;

  return (
    <div className="border-[1px] border-gray-200 rounded-lg p-4 @container">
      <div className="w-full @xl:grid @xl:grid-cols-5 @xl:gap-4">
        <div className="mt-3 @xl:col-span-3">
          <div className="text-gray-600 font-bold text-xl">
            {designation.name}
          </div>

          <DetailRow label="Designation ID" value={designation.id} />
          <DetailRow label="Name" value={designation.name} />
          <DetailRow label="Department" value={designation.departmentName} />

          <div className="mt-2 flex flex-row items-center text-gray-700">
            <div className="w-[140px] flex-shrink-0 text-sm mr-2">Status</div>
            <StatusBadge
              statusId={designation.statusId}
              statusName={designation.statusName}
            />
          </div>

          <DetailRow label="Created By" value={designation.createdBy} />
          <DetailRow label="Created At" value={designation.createdAt} />
          <DetailRow
            label="Last Changed By"
            value={designation.lastChangedBy}
          />
          <DetailRow
            label="Last Changed At"
            value={designation.lastChangedAt}
          />
        </div>
      </div>
    </div>
  );
}

export default DesignationOverview;
